import type { LocationQuery } from '#vue-router'

export const queryValueToBoolean = (value: LocationQuery[string]): boolean => queryValueToString(value) === 'true'
